import Breadcrumb from "components/Common/Breadcrumb"
import React, { useState } from "react"
import { Card, CardBody, Button, Badge, Input } from "reactstrap"
import { FaCheckCircle, FaTrash, FaBell } from "react-icons/fa"
import moment from "moment"

const Notifications = () => {
  const [filter, setFilter] = useState("all")

  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "New Document Imported",
      message: "Invoice INV-2026-001 has been uploaded.",
      type: "info",
      read: false,
      date: "2026-03-02 10:30",
    },
    {
      id: 2,
      title: "Vendor Approved",
      message: "Vendor ABC Enterprises has been approved.",
      type: "success",
      read: false,
      date: "2026-03-01 14:15",
    },
    {
      id: 3,
      title: "Product Updated",
      message: "Gold Ring SKU-1001 updated successfully.",
      type: "warning",
      read: true,
      date: "2026-02-28 09:00",
    },
  ])

  /* ================= FILTER ================= */

  const filteredNotifications =
    filter === "unread" ? notifications.filter(n => !n.read) : notifications

  /* ================= ACTIONS ================= */

  const markAsRead = id => {
    setNotifications(prev =>
      prev.map(n => (n.id === id ? { ...n, read: true } : n))
    )
  }

  const deleteNotification = id => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }

  const unreadCount = notifications.filter(n => !n.read).length

  return (
    <div className="page-content">
      <Breadcrumb title="Dashboard" breadcrumbItem="Notifications" />

      <Card>
        <CardBody>
          {/* ===== HEADER BAR ===== */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-2">
              <FaBell size={20} />
              <h5 className="mb-0">Notifications</h5>
              {unreadCount > 0 && <Badge color="danger">{unreadCount}</Badge>}
            </div>

            <Input
              type="select"
              style={{ width: "150px" }}
              value={filter}
              onChange={e => setFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="unread">Unread</option>
            </Input>
          </div>

          {/* ===== LIST ===== */}
          {filteredNotifications.length === 0 && (
            <div className="text-center text-muted">No Notifications Found</div>
          )}

          {filteredNotifications.map(notification => (
            <div
              key={notification.id}
              className={`p-3 mb-3 rounded border ${
                notification.read ? "bg-light" : "bg-white shadow-sm"
              }`}
            >
              <div className="d-flex justify-content-between">
                <div>
                  <h6 className="mb-1">
                    {notification.title}
                    {!notification.read && (
                      <Badge color="primary" className="ms-2">
                        New
                      </Badge>
                    )}
                  </h6>

                  <p className="mb-1 text-muted">{notification.message}</p>

                  <small className="text-secondary">
                    {moment(notification.date).fromNow()}
                  </small>
                </div>

                <div className="d-flex align-items-center gap-2">
                  {!notification.read && (
                    <Button
                      size="sm"
                      color="success"
                      onClick={() => markAsRead(notification.id)}
                    >
                      <FaCheckCircle />
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </div>
  )
}

export default Notifications
